import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import SmartToyIcon from '@material-ui/icons/SmartToy';
import MenuBookIcon from '@material-ui/icons/MenuBook';

export const guildAgenda = [
  {
    time: '10:00 AM',
    title: 'Módulo I: Dominio del ecosistema',
    icon: RecordVoiceOverIcon,
    bullets: [
      {
        lead: 'La nueva narrativa:',
        text: ' Inmersión en el speech oficial. Aprenderemos a comunicar nuestra identidad: Streaming, On-Demand y Digest.',
      },
      {
        lead: 'Vocabulario tecnológico:',
        text: ' Por qué ya no somos «radio» y cómo defender nuestra posición como ecosistema multiplataforma.',
      },
    ],
  },
  {
    time: '11:30 AM',
    title: 'Módulo II: Estrategia comercial y media kits',
    icon: BusinessCenterIcon,
    bullets: [
      {
        lead: 'Nuevos media kits 2026:',
        text: ' Presentación oficial de las nuevas herramientas visuales para presentar tu marca.',
      },
      {
        lead: 'Productos de comercialización actuales:',
        text: ' Desglose de nuestra oferta: menciones en vivo, banners en Digest, slots en On-Demand y presencia en eventos.',
      },
      {
        lead: 'Venta con propósito:',
        text: ' Cómo usar nuestras métricas de conexión orgánica para cerrar aliados de alto nivel.',
      },
    ],
  },
  {
    time: '1:00 PM',
    title: 'Break: networking creativo',
    icon: LocalCafeIcon,
    isBreak: true,
    bullets: [{ lead: '', text: 'Espacio para conectar con colegas y el equipo antes del bloque de tarde.' }],
  },
  {
    time: '2:00 PM',
    title: 'Módulo III: Roadmap tecnológico — inteligencia artificial',
    icon: SmartToyIcon,
    bullets: [
      {
        lead: 'IA en la plataforma:',
        text: ' Presentación del nuevo chatbot de usuario para navegación asistida y soporte.',
      },
      {
        lead: 'Algoritmos de recomendación:',
        text: ' Cómo la plataforma usará IA para sugerir tus contenidos a la audiencia correcta según intereses reales.',
      },
      {
        lead: 'Optimización de procesos:',
        text: ' Herramientas del Media Lab para potenciar tu productividad.',
      },
    ],
    showIaDiagram: true,
  },
  {
    time: '3:30 PM',
    title: 'Módulo IV: The Digest y cierre',
    icon: MenuBookIcon,
    bullets: [
      {
        lead: 'Del micrófono al texto:',
        text: ' Cómo transformamos cada programa en piezas de profundidad editorial.',
      },
      {
        lead: 'Q&A:',
        text: ' Sesión abierta con la dirección tecnológica y editorial sobre la visión de expansión 2026.',
      },
    ],
  },
];

/** Diagrama minimalista: streaming → IA → digest + on-demand (Hybrid Shift). */
export function EcosystemIntelligentDiagram() {
  const nodeSx = {
    px: 2,
    py: 1.5,
    borderRadius: 2,
    fontWeight: 700,
    fontSize: '0.875rem',
    textAlign: 'center',
    minWidth: { xs: 96, sm: 112 },
  };
  const arrow = { color: 'primary.main', fontWeight: 900, fontSize: '1.1rem', lineHeight: 1 };
  return (
    <Box
      sx={{
        mt: 3,
        p: 3,
        borderRadius: 2,
        bgcolor: 'rgba(46,125,50,0.06)',
        border: '1px dashed',
        borderColor: 'primary.light',
      }}
    >
      <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 800, mb: 2, textAlign: 'center' }}>
        Ecosistema inteligente · flujo de conexión
      </Typography>
      <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="center" gap={0.75}>
        <Box sx={{ ...nodeSx, bgcolor: 'rgba(229,57,53,0.12)', color: '#b71c1c' }}>Streaming</Box>
        <Typography component="span" sx={arrow}>→</Typography>
        <Box sx={{ ...nodeSx, bgcolor: 'rgba(46,125,50,0.2)', color: 'primary.dark' }}>IA recomienda</Box>
        <Typography component="span" sx={arrow}>→</Typography>
        <Box sx={{ ...nodeSx, bgcolor: 'rgba(0,105,92,0.12)', color: '#004d40' }}>Digest</Box>
        <Typography component="span" sx={{ ...arrow, px: 0.25 }}>+</Typography>
        <Box sx={{ ...nodeSx, bgcolor: 'rgba(94,53,177,0.12)', color: '#4a148c' }}>On-Demand</Box>
      </Box>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', textAlign: 'center', mt: 2, maxWidth: 520, mx: 'auto' }}>
        El algoritmo enlaza tu programa en vivo con piezas de profundidad editorial y sugerencias en catálogo para quien
        realmente las va a ver.
      </Typography>
    </Box>
  );
}
